export default __webpack_public_path__ + "static/media/fridge1-before2-1440w.da342381.png";